webpackJsonp([50739212244294],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(25);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronLeft = function FaChevronLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.1 6.7l-11.8 11.9 11.8 11.8q0.5 0.4 0.5 1t-0.5 1l-3.7 3.7q-0.4 0.5-1 0.5t-1-0.5l-16.5-16.5q-0.5-0.4-0.5-1t0.5-1l16.5-16.6q0.5-0.4 1-0.4t1 0.4l3.7 3.7q0.5 0.4 0.5 1t-0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaChevronLeft;
	module.exports = exports['default'];

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Link;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Link(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      to = _ref.to;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: ['link'].concat(className || []).join(' '), to: to },
	    children
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Tags;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _chevronLeft = __webpack_require__(80);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _Link = __webpack_require__(58);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(122);
	
	__webpack_require__(73);
	
	__webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tags(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var posts = pathContext.posts,
	      post = pathContext.post,
	      tag = pathContext.tag;
	
	  if (tag) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'ul',
	        { className: 'list blog-posts' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'serif italic tag-header' },
	          post.length,
	          ' post',
	          post.length === 1 ? '' : 's',
	          ' tagged with \u201C',
	          tag,
	          '\u201D'
	        ),
	        post.map(function (_ref2) {
	          var id = _ref2.id,
	              frontmatter = _ref2.frontmatter,
	              excerpt = _ref2.excerpt;
	
	          return _react2.default.createElement(
	            'li',
	            { key: id, className: 'link' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: frontmatter.path,
	                className: 'blog-post-preview link',
	                key: post.id },
	              _react2.default.createElement(
	                'h2',
	                { className: 'date' },
	                frontmatter.date
	              ),
	              _react2.default.createElement(
	                'h1',
	                { className: 'title serif-display' },
	                frontmatter.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                excerpt
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'link--fill sans-serif' },
	                'Read more'
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/tags', className: 'sans-serif no-underline bold' },
	        _react2.default.createElement(_chevronLeft2.default, {
	          style: {
	            height: '1rem'
	          }
	        }),
	        'All topics'
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      { className: 'serif italic tag-header' },
	      'Topics'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'tags' },
	      Object.keys(posts).map(function (tagName) {
	        var tags = posts[tagName];
	        return _react2.default.createElement(
	          'li',
	          { key: tagName },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: '/tags/' + tagName,
	              className: 'sans-serif bold tag' },
	            tagName
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _Link2.default,
	      { to: '/', className: 'sans-serif no-underline bold' },
	      _react2.default.createElement(_chevronLeft2.default, {
	        style: {
	          height: '1rem'
	        }
	      }),
	      'All posts'
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-552d9f6d40011c09a491.js